import type {MouseEvent} from 'react';
import React from 'react';

import type {RouteComponentProps} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import {Button} from 'antd';
import type {ButtonProps as NativeButtonProps} from 'antd';
import type {History} from 'history';

interface IButtonLinkProps extends NativeButtonProps {
  to: string;
  state?: unknown;
}

// eslint-disable-next-line react-refresh/only-export-components
const C: React.FC<IButtonLinkProps & RouteComponentProps> = ({
  to,
  state,
  history,
  staticContext: _staticContext,
  match: _match,
  location: _location,
  ...props
}) => {
  const typedHistory = history as History;

  return (
    <Button
      {...props}
      htmlType="button"
      onClick={(e: MouseEvent<HTMLElement>) => {
        // Only prevent default for plain left-clicks (no modifier keys, no non-primary button)
        if (e.button === 0 && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey) {
          e.preventDefault();
          typedHistory.push(to, state);
        }
      }}
      href={to}
    />
  );
};

export const ButtonLink = withRouter(C);
